import axios from "axios";
const Instance = axios.create({
  baseURL: "https://rahelapi.erp-softgroup.link",
  // Fail fast instead of hanging forever: without this, a slow/dead backend
  // leaves search/save calls pending indefinitely, so their loading spinner
  // never stops and the disabled form never re-enables. Raise for heavy report
  // endpoints if any legitimately take longer than this.
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
    Authorization: "Bearer " + localStorage.token
  }
});
export default Instance;
